module.exports = "<div class=\"remove-mac\">{{t('actionMacFilter.removingMac', {mac: mac})|e}}</div>\n";
